// node_modules
import MarkdownIt from "markdown-it";
import StateCore from "markdown-it/lib/rules_core/state_core";
import Token from "markdown-it/lib/token";

const modifyLink = (token: Token, env: any | undefined = undefined): void => {
    // check if the current token & token.attrs is null
    if (!token || !token.attrs) return;

    let isLinkToIgorInternalData = false;
    let isLinkToInternalLinkOrImageOrVideo = false;
    for (const attr of token.attrs) {
        if (attr[0] === "href" && attr[1].startsWith("#")) {
            isLinkToIgorInternalData = true;
            if (attr[1].toLowerCase().includes("internallink") || 
            attr[1].toLowerCase().includes("image") || 
            attr[1].toLowerCase().includes("video")) {isLinkToInternalLinkOrImageOrVideo = true;}
            break;
        }
    }
    
    if (isLinkToIgorInternalData) {
        const technologyId: string | undefined = env && env.technologyId ? env.technologyId : undefined;
        // If it's a link to an internal link,image or video, add the technology id to the link
        // It's needed to retrieve the internal link, image or video data 
        // in the modal opened when clicking on the link
        if (isLinkToInternalLinkOrImageOrVideo && technologyId) {
            for (const attr of token.attrs) {
                if (attr[0] === "href" && attr[1].startsWith("#")) {
                    attr[1] += `-${technologyId}`;
                }
            }
        }
    } else {
        // change the relationship between the current document and the linked document
        // specifying that is a link to an unendorsed document and make referrer unknown
        // and change the target to opens the linked document in a new window or tab
        token.attrs.push(["ref", "noopener noreferrer"], ["target", "_blank"]);
    }
};

export const addModifyLinkExtension = (markdownIt: MarkdownIt): void => {
    markdownIt.core.ruler.after(
        "inline",
        "markdown-it-modify-link",
        (state: StateCore) => {
            state.tokens.forEach((value: Token) => {
                if (value.type === "inline" && value.children) {
                    value.children.forEach((token: Token) => {
                        const type: string = token.type;
                        if (type === "link_open") {
                            modifyLink(token, state.env);
                        }
                    });
                }
            });
            return false;
        }
      );
};